import React from "react";

const BS5_Scrollspy = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Scrollspy Component</h2>
      <p>This is the BS5_Scrollspy component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Scrollspy;
